// extracted by mini-css-extract-plugin
export default {"container":"Container_container__0DJzi"};